<template>
    <div class="whole flex column">
        <div class="header">
            <HeadBar></HeadBar>
        </div>
        <div class="main-content flex justify-content">
            <div class="left flex column align">
                <div class="flex">
                    <img class="iconAvatar" src="@/assets/AI/iconAvatar.png" alt="">
                    <div class="userName">康康</div>
                </div>
                <div class="newDialogueBox flex align">
                    <img class="iconNewDialogue" src="@/assets/AI/iconNewDialogue.png" alt="">
                    <div class="newDialogueText">开启新对话</div>
                </div>
                <div class="historyDialogueBox flex align spaceBetween">
                    <div class="flex align">
                        <img class="iconHistoryDialogue" src="@/assets/AI/iconHistoryDialogue.png" alt="">
                        <div class="newDialogueText">历史对话</div>
                    </div>
                    <img class="iconUnfold" src="@/assets/AI/iconUnfold.png" alt="">
                </div>
                <div class="starChartsBox flex align">
                    <img class="iconStarCharts" src="@/assets/AI/iconStarCharts.png" alt="">
                    <div class="starChartsText">AI知识星图</div>
                </div>
                <img class="btnReturn" src="@/assets/AI/btnReturn.png" alt="" @click="goBack">
            </div>
            <div class="right flex column align">
                <div class="chart-container" style="width: 100%; height: 100%;">
                    <ForceRelationChart :nodes="chartNodes" :links="chartLinks" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadBar from "@/views/layout/components/header.vue";
import ForceRelationChart from "@/components/echarts/ForceRelationChart.vue";
import { getStarCloud } from "@/api/index.js";
export default {
    data() {
        return {
            chartNodes: [],
            chartLinks: []
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    },
    components: {
        HeadBar,
        ForceRelationChart
    },
    created() {
        // 颜色淡化函数 - 将颜色转换为带透明度的rgba格式，根据层级调整透明度
        const lightenColor = (hexColor, level) => {
            // 解析十六进制颜色
            const r = parseInt(hexColor.slice(1, 3), 16);
            const g = parseInt(hexColor.slice(3, 5), 16);
            const b = parseInt(hexColor.slice(5, 7), 16);

            // 定义不同层级的透明度
            const opacityMap = {
                1: 1,       // 第一层节点 - 完全不透明
                2: 0.7,     // 第二层节点 - 70%不透明
                3: 0.4      // 第三层节点 - 40%不透明
            };

            const opacity = opacityMap[level] || 1;
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        };

        getStarCloud().then((res) => {
            // console.log(res.data.datas);
            // 初始化数据数组，包含默认的医药云课堂，设置中心节点颜色（最浓）
            let data = [{ name: '医药云课堂', symbolSize: 30, itemStyle: { color: '#1890ff' } }];
            let dataLinks = [];

            // 颜色映射表，用于存储不同部门的原始颜色
            const departmentColors = {};
            // 预定义颜色数组
            const colors = ['#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#fa8c16', '#eb2f96', '#a0d911', '#fa541c', '#2f54eb'];
            let colorIndex = 0;

            // 从res.data.datas中提取category的department值并添加到data数组
            if (res.data.datas && Array.isArray(res.data.datas)) {
                res.data.datas.forEach(item => {
                    // 检查并添加不重复的分类名称
                    if (item.category) {
                        // 处理category.department - 第一层节点（原始颜色，不淡化）
                        if (item.category.department) {
                            const existingDept = data.find(node => node.name === item.category.department);
                            if (!existingDept) {
                                // 为部门节点分配颜色
                                const color = colors[colorIndex % colors.length];
                                departmentColors[item.category.department] = color;
                                colorIndex++;

                                data.push({
                                    name: item.category.department,
                                    symbolSize: 30,
                                    itemStyle: { color: lightenColor(color, 1) } // 第一层使用原始颜色
                                });
                                dataLinks.push({ source: '医药云课堂', target: item.category.department });
                            }
                        }

                        // 处理category.name - 第二层节点（比第一层淡）
                        if (item.category.name && item.category.department) {
                            const existingName = data.find(node => node.name === item.category.name);
                            if (!existingName) {
                                // 获取对应部门的原始颜色
                                const parentColor = departmentColors[item.category.department];

                                data.push({
                                    name: item.category.name,
                                    symbolSize: 30,
                                    itemStyle: { color: lightenColor(parentColor, 2) } // 第二层颜色淡化
                                });
                                // category.name节点连接到对应的category.department节点
                                dataLinks.push({ source: item.category.department, target: item.category.name });
                            }
                        }

                        // 处理lessons数组 - 第三层节点（比第二层淡）
                        if (item.lessons && Array.isArray(item.lessons)) {
                            item.lessons.forEach(lesson => {
                                // 当lessons.category_id等于category.id时
                                if (lesson.category_id === item.category.id && lesson.user && lesson.user.name) {
                                    // 检查是否已经存在相同名称的用户节点
                                    const existingUser = data.find(node => node.name === lesson.user.name);
                                    if (!existingUser) {
                                        // 获取对应分类的原始颜色
                                        const categoryNode = data.find(node => node.name === item.category.name);
                                        const parentColor = categoryNode ? departmentColors[item.category.department] : '#8c8c8c';

                                        // 添加用户节点，颜色进一步淡化
                                        data.push({
                                            name: lesson.user.name,
                                            symbolSize: 20,
                                            itemStyle: { color: lightenColor(parentColor, 3) } // 第三层颜色更淡
                                        });
                                        // 创建与category.name的连接
                                        dataLinks.push({ source: item.category.name, target: lesson.user.name });
                                    }
                                }
                            });
                        }
                    }
                });
            }

            // 将数据赋值给组件数据属性
            this.chartNodes = data;
            this.chartLinks = dataLinks;
        })
    }
}
</script>

<style src="./aiAssistant.css"></style>